import React from 'react';
import {CountryLinksWithRegion} from './Types';
import { Text, useIsMobile, Icon } from '@amzn/storm-ui';
import { spinner } from '@amzn/storm-ui-icons';
import styled from 'styled-components';
import {CountryListDesktop} from './CountryListDesktop';
import {CountryListMobile} from './CountryListMobile';
import { useBundle } from '@amzn/react-arb-tools';
import { CountrySelectorMetricsPublisher, InterstitialPageMetricsPublisher } from '../metrics';
import { useAccountContext } from './AccountContextProvider';

const CountryLinksLabel = styled(Text)`
  padding-top: 12px;
  padding-bottom: 4px;
  padding-inline-start: 20px;
`;

type CountryLinksSectionProps = {
  countryLinksWithRegion: CountryLinksWithRegion;
};

export const CountryLinksSection: React.VFC<CountryLinksSectionProps> =
  ({countryLinksWithRegion}) => {
    const { numberOfAccountSelection } = useAccountContext();
    const isMobile = useIsMobile();
    const region = countryLinksWithRegion.region;
    const countryLinks = countryLinksWithRegion.countryLinks;
    const [bundle, isBundleLoading] = useBundle('pages.interstitial');

    if (countryLinks.length === 0) {
      return null;
    }

    if (isBundleLoading) {
      return <Icon type={spinner}></Icon>
    }

    const regionLabel = bundle.getMessage(region);

    const handleClick = (url?) => {
      CountrySelectorMetricsPublisher.publishCounterMonitor('select', 1);
      InterstitialPageMetricsPublisher.publishCounterMonitor('account_selection', numberOfAccountSelection);
      if (url) {
        window.location.href = url;
      }
    }

    return (
      <div key={region}>
        <CountryLinksLabel type="h4" styleAs="h5">{regionLabel}</CountryLinksLabel>
        {!isMobile && <CountryListDesktop countryLinks={countryLinksWithRegion.countryLinks} handleClick={handleClick}/>}
        {isMobile && <CountryListMobile countryLinks={countryLinksWithRegion.countryLinks} handleClick={handleClick}/>}
      </div>
    );
}
